<template>
  <AllRecordsTable
    submit-button-text="Добавить пользователя"
    table-name="users"
    link-slug="users"
    image-subfolder="users"
    title="Пользователи"
    :foreign-key-values="usersTable.foreignKeyValues"
    :filter-fields="usersTable.filterFields"
    :columns="usersTable.columnNames"
    :order-fields="usersTable.orderFields"
    :rows="usersTable.rowNames"
  />
</template>

<script>
import AllRecordsTable from "@/_shared/widgets/AllRecordsTable";
import { lists } from "@/user/constants";
export default {
  components: {
    AllRecordsTable,
  },
  data() {
    return {
      usersTable: lists.users,
    };
  },
  provide() {
    return {
      nameFilterLabel: 'Имя',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/user/pages/AllUsersPage.vue